import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AFRegistrationDomain } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ShowLoaderEvent } from '../service/events';

@Injectable({
  providedIn: 'root'
})

export class AuthguardVendor {

  constructor(private userService: AuthService, private router: Router, private eventBus: EventService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    const verifyId: string = route.queryParams['verifyId'];

    if (verifyId != null) {
      sessionStorage.setItem('verifyId', verifyId);
      localStorage.setItem('verifyIdLocal', verifyId);
      localStorage.setItem('loginType', "4");
    } else if (this.userService.getVerifyId() == null) {
      this.router.navigate(['unauthorized']);
    }

    this.eventBus.emit(new ShowLoaderEvent({ show: false }));
    this.userService.getVendorDetails().subscribe({
      next: (data: AFRegistrationDomain) => {
        sessionStorage.setItem(environment.user_vendor_object, JSON.stringify(data));
        this.eventBus.emit(new ShowLoaderEvent({ show: true }));
        if (data.view == "signInView") {
          this.router.navigate(['login']);
        } else if (data.view == "createVendorProfile") {
          this.router.navigate(['createVendorAccount']);
        } else {
          this.router.navigate(['unauthorized']);
        }
      },
      error: () => {
        this.router.navigate(['unauthorized']);
        this.eventBus.emit(new ShowLoaderEvent({ show: true }));
      }
    });

    return true;
  }
}
